/* tslint:disable */

/**
 */
export class RpTicketDestroyForm {
    transaction_id?: number;
    shift_id?: number;
    ticket_price_id?: number;
    ticket_number?: string;
    amount?: number;
    type?: string;
    printed_at?: string;
    description?: string;
    image?: string;
    subuser_id?: number;
}
